import type { NavigationMessages } from '@/i18n/messages';

export type ReportPageId =
  | 'overview'
  | 'userCost'
  | 'pricing'
  | 'trialRisk'
  | 'behavior'
  | 'revenue';

export interface ReportPageItem {
  id: ReportPageId;
  path: string;
  navigationKey: keyof NavigationMessages;
  tabKey: 'overview' | 'users' | 'pricing' | 'trial' | 'behavior' | 'revenue';
}

export const reportPageItems: ReportPageItem[] = [
  {
    id: 'overview',
    path: '/reports/overview',
    navigationKey: 'reportsOverview',
    tabKey: 'overview',
  },
  {
    id: 'userCost',
    path: '/reports/user-cost',
    navigationKey: 'reportUserCost',
    tabKey: 'users',
  },
  {
    id: 'pricing',
    path: '/reports/pricing',
    navigationKey: 'reportPricingAnalysis',
    tabKey: 'pricing',
  },
  {
    id: 'trialRisk',
    path: '/reports/trial-risk',
    navigationKey: 'reportTrialRisk',
    tabKey: 'trial',
  },
  {
    id: 'behavior',
    path: '/reports/behavior',
    navigationKey: 'reportUserBehavior',
    tabKey: 'behavior',
  },
  {
    id: 'revenue',
    path: '/reports/revenue',
    navigationKey: 'reportRevenueAnalysis',
    tabKey: 'revenue',
  },
];

export function getReportPageItem(id: ReportPageId): ReportPageItem {
  return reportPageItems.find((item) => item.id === id) ?? reportPageItems[0];
}

const legacyReportPathByTab: Record<string, string> = {
  overview: '/reports/overview',
  users: '/reports/user-cost',
  pricing: '/reports/pricing',
  trial: '/reports/trial-risk',
  behavior: '/reports/behavior',
  revenue: '/reports/revenue',
};

export function getLegacyReportRedirectPath(tab?: string): string {
  if (!tab) {
    return '/reports/overview';
  }

  return legacyReportPathByTab[tab] ?? '/reports/overview';
}
